import { render, staticRenderFns } from "./menu-form.vue?vue&type=template&id=1e9327ac"
import script from "./menu-form.vue?vue&type=script&lang=js"
export * from "./menu-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e9327ac')) {
      api.createRecord('1e9327ac', component.options)
    } else {
      api.reload('1e9327ac', component.options)
    }
    module.hot.accept("./menu-form.vue?vue&type=template&id=1e9327ac", function () {
      api.rerender('1e9327ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/menu-form.vue"
export default component.exports